import { render, staticRenderFns } from "./InformacaoAgriculaAr.vue?vue&type=template&id=3c6855b0&scoped=true&lang=pug"
import script from "./InformacaoAgriculaAr.vue?vue&type=script&lang=js"
export * from "./InformacaoAgriculaAr.vue?vue&type=script&lang=js"
import style0 from "./InformacaoAgriculaAr.vue?vue&type=style&index=0&id=3c6855b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6855b0",
  null
  
)

export default component.exports